<template>
  <div>
    <canvas id="myChart" ref="canvas" height="120px"></canvas>
  </div>
</template>

<script>
import { Bar } from "vue-chartjs";

export default {
  props: {
    actes_chart: {},
    annee_academique: "",
  },
  extends: Bar,
  mounted() {
    // Overwriting base render method with actual data.
    this.renderChart(
      {
        labels: this.actes_chart.labels,
        datasets: [
          {
            label: "Actes d'engagements valide " + this.annee_academique,
            backgroundColor: "#003667",
            data: this.actes_chart.values,
          },
        ],
      },
      {
        scales: {
          xAxes: [
            {
              ticks: {
                fontSize: 8,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                fontSize: 10,
              },
            },
          ],
        },
      }
    );
  },
};
</script>
